export default __webpack_public_path__ + "static/media/HelloHand.8e8c82c3.svg";